import * as e from "react";
const c = (a) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    id: "expedia_svg__svg2",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 2383.7 2196.8",
    xmlSpace: "preserve",
    ...a
  },
  /* @__PURE__ */ e.createElement("style", null, ".expedia_svg__st1{fill:#072f54}"),
  /* @__PURE__ */ e.createElement("circle", { cx: 1191.8, cy: 1098.4, r: 992.7, fill: "#fbc108" }),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      id: "expedia_svg__path4354",
      className: "expedia_svg__st1",
      d: "M940.7 1406.9h-66.4c-.4 0-.4 0-.6-.2l-57.1-69.7-57.1 69.7c-.2.2-.4.2-.6.2h-53.1c-.4 0-.6-.2-.8-.4 0-.2 0-.6.2-.8l84.2-103.4L706 1200c-.2-.4-.2-.6-.2-1.1.2-.2.4-.4.6-.4h66.4c.2 0 .4.2.6.4l50.2 62.2 51-62.2c.2-.2.4-.4.6-.4h54c.2 0 .6.2.8.4.2.4 0 .6-.2 1.1l-78.8 94.7 90.3 110.9c.2.2.2.6.2.8-.2.5-.4.5-.8.5"
    }
  ),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      id: "expedia_svg__path4358",
      className: "expedia_svg__st1",
      d: "M1299.7 1235.1c-29.4 0-49.4 17.9-55.3 48.7h100v-2.1c0-24.6-18.2-46.6-44.7-46.6m96.2 80.7c-.2.2-.4.4-.6.4h-151.9c3.2 35.3 26 55.5 63.2 55.5 22.9 0 47.3-7.8 81.5-26 .6-.4 1.3.2 1.3.8v46.6c0 .4-.2.6-.4.6-31.9 13.4-64.1 22.7-89.3 22.7-65.3 0-112.8-47.7-112.8-113.2s47.5-113.2 112.8-113.2c59.7 0 97.9 40.1 97.9 95.4 0 8.9-1.5 29.7-1.7 30.4"
    }
  ),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      id: "expedia_svg__path4362",
      className: "expedia_svg__st1",
      d: "M1704.3 1155.3c-18.7 0-33.8-14.9-33.8-33.2 0-18.9 15.1-34.2 33.8-34.2 18.7 0 33.8 15.3 33.8 34.2 0 18.2-15.1 33.2-33.8 33.2m-27.3 251.6c-.6 0-.8-.2-.8-.8v-206.9c0-.4.2-.8.6-.8h54.8c.4 0 .6.4.6.8v206.9c0 .6-.4.8-.8.8H1677z"
    }
  ),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      id: "expedia_svg__path4366",
      className: "expedia_svg__st1",
      d: "M1041.1 1375.8c-9.9 0-20-1.5-31.7-4.4l.2-132.8c13.7-4.4 25.4-6.3 37.2-6.3 38 0 63.4 27.9 63.4 69.7 0 44.8-27.1 73.8-69.1 73.8m14.9-185.9c-15.5 0-31.1 2.7-47.5 8.4h-54.6c-.4 0-.8.4-.8.8v339.3c16.4-2.3 36.6-8.2 56.3-22.1v-103.1c13.4 1.9 24.6 3.2 35.3 3.2 74.8 0 123.1-44.7 123.1-114.1 0-66.2-46-112.4-111.8-112.4"
    }
  ),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      id: "expedia_svg__path4370",
      className: "expedia_svg__st1",
      d: "M1577.2 1358.6c-17 9-32.4 13.2-46.6 13.2-33.8 0-54.2-23.9-54.2-64.1 0-46.2 25.8-76.3 66-76.3 11.1 0 21.8 2.7 34.9 8.6v118.6zm0-269.7v108.2c-16-4.6-30-6.7-44.3-6.7-65.1 0-114.1 48.9-114.1 114.1 0 64.7 43.3 111.8 102.9 111.8 20.6 0 39.9-5.3 62.6-16.8v18.7c14.9-2.9 32.1-8.8 49.2-21v-330.5c-16.6 2.2-36.3 7.9-56.3 22.2"
    }
  ),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      id: "expedia_svg__path4374",
      className: "expedia_svg__st1",
      d: "M1922.4 1358.2c-16.6 9.5-30.7 14.1-43.3 14.1-36.3 0-58-23.9-58-64.1 0-45.6 25.6-76.3 63.7-76.3 10.1 0 22.5 4 37.6 12v114.3zm56.3-162.4c0-1.3-1.1-2.3-2.3-2.3H1932c-1.3 0-2.5 1.1-2.5 2.3v7.6h-1.1c-20.4-9-38-13-55-13-61.3 0-109.5 50.8-109.5 116 0 65.8 43.1 109.9 107.1 109.9 17 0 39.1-1.3 59.7-24.8v26.7c14.5-3.2 31.7-9.2 47.9-21l.1-201.4z"
    }
  ),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      id: "expedia_svg__path4378",
      className: "expedia_svg__st1",
      d: "M553.9 1355.3h137.6c-2.1 15.3-7.4 33.4-19.1 51.7H529.3c-17.4 0-31.9-13.7-33.6-30.7 0-.2-.2-.4-.2-.8V1104c0-.2.2-.4.2-.6 1.7-17.2 16.2-30.9 33.6-30.9h162c-2.1 15.3-7.4 33.8-19.3 52.1H553.9v73.9h117c.4 0 .8.4.8.8v51.3c0 .4-.4.8-.8.8h-117v103.9z"
    }
  ),
  /* @__PURE__ */ e.createElement("g", null, /* @__PURE__ */ e.createElement(
    "path",
    {
      id: "expedia_svg__path4398",
      className: "expedia_svg__st1",
      d: "M1279.1 705.6l-9.9-28.2-84.9-113.2 15.1-3.8 146 126.3 85.9-24.6c10.1-2.5 21.6-3.2 30.3-3.2-26.9-58.2-76.5-106.1-141.6-129.2-128.8-46-270.6 21.4-316.4 150.4-14.3 39.9-17.4 81.1-11.6 120.2l205.7-71.4 81.4-23.3z"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      id: "expedia_svg__path4402",
      className: "expedia_svg__st1",
      d: "M1470.9 681.3c-7.6 4.8-18.7 11.3-29.6 14.9l-86.1 24.6-57.4 184.4-14.9 4.8 12.2-140.8-6.7-29.2-80.7 23.1L994.2 813c17 81.9 75 153.6 159.7 183.6 129 46 270.6-21.4 316.6-150.4 19.7-55.3 18.5-113.2.4-164.9"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      id: "expedia_svg__path4406",
      d: "M1288.1 739.9l6.7 29.2-12.2 140.8 14.9-4.8 57.4-184.4 86.1-24.6c10.9-3.6 22.1-9.9 29.6-14.9-2.7-7.6-5.7-14.9-9-22.3-8.8 0-20.2.4-30.3 3.2l-85.9 24.6-146-126.3-15.1 3.8 84.7 113.2 9.9 28.2-81.3 23.3-205.7 71.4c.6 4.2 1.5 8.6 2.3 12.8l213.2-50.2 80.7-23z",
      fill: "#fff"
    }
  ))
);
export {
  c as default
};
